import { cn } from '#app/utils/misc'

interface CarouselProgressProps {
	count: number
	activeIndex: number
	onSelect?: (index: number) => void
	className?: string
	activeDotClassName?: string
	inactiveDotClassName?: string
	getAriaLabel?: (index: number) => string
}

export function CarouselProgress({
	count,
	activeIndex,
	onSelect,
	className,
	activeDotClassName,
	inactiveDotClassName,
	getAriaLabel,
}: CarouselProgressProps) {
	if (count <= 1) return null

	return (
		<div className={cn('flex items-center gap-2', className)}>
			{Array.from({ length: count }, (_, index) => {
				const isActive = index === activeIndex
				return (
					<button
						key={index}
						type="button"
						onClick={() => onSelect?.(index)}
						aria-label={getAriaLabel?.(index)}
						aria-current={isActive ? 'true' : undefined}
						className={cn(
							'h-2.5 rounded-full transition-all',
							isActive
								? 'w-6 bg-current'
								: 'w-2.5 bg-current/40 hover:bg-current/60',
							isActive ? activeDotClassName : inactiveDotClassName,
						)}
					/>
				)
			})}
		</div>
	)
}
